module.exports = __webpack_public_path__ + "img/icon_report_empty_logo_2.72a035cd.png";